<template>
    <div class="mb-0" id="mainHeader">
        <div v-if="displayModalJackpot">
            <modal-jackpot @openclosedmodal="openjackpot" v-bind:skin="skin" />
        </div>
        <nav class="navbar my-0 navbar-expand-lg bg-body-tertiary" :style="skin.header_desktop.nav_bar">
            <div class="container-fluid my-0">
                <div class="float-left" @click="change_view('lobby')" style="cursor:pointer;">
                    <img v-if="skin.header_desktop.logo != ''" :src="skin.header_desktop.logo"
                        :width="skin.header_desktop.logo_width" alt="" style="max-width: 170px;max-height: 45px;">
                </div>
                <div style="width: 80%;display: flex;justify-content: center;align-items: center;" id="navbarText">
                    <div class="">
                        <ul id="menu-zeus" class="nav nav-tabs" :style="active_item">
                            <li v-for="(item, index) in filteredCategories" :key="index" @click="change_view(index)"
                                class="nav-item" role="presentation">
                                <button :class="['nav-link', 'text-center', { active: isActive(item) }]" type="button"
                                    style="text-transform: uppercase;">
                                    <span>{{ translate(item.name) }}</span>
                                </button>
                            </li>

                        </ul>
                    </div>
                </div>
                <div v-if="user.token != ''" class="d-flex align-items-center">
                    <button v-if="skin.jackpot" @click="openjackpot" class="jackpot-btn gold-glow"
                        :style="{ '--color': skin.header_desktop.jackpot[0], '--color1': skin.header_desktop.jackpot[1], '--colorletter': skin.header_desktop.jackpot[2] }">Jackpot</button>
                    <div v-if="user.token != '' && skin.auto_payment?.enabled" @click="payment"
                        :style="skin.header_desktop.login_btn"
                        class="btn btn-sm text-end mx-1 d-flex align-items-center">
                        <i class="fas fa-plus fa-fw me-1" style="font-size: 14px;"></i> <!-- Ícono de depósito -->
                        <span style="font-size: 12px;">DEPOSIT</span> <!-- Texto de depósito -->
                    </div>

                    <div v-if="user.token != '' && skin.auto_payment?.enabled" @click="withdraw"
                        :style="skin.header_desktop.login_btn"
                        class="btn btn-sm text-end mx-1 d-flex align-items-center">
                        <i class="fas fa-minus fa-fw me-1" style="font-size: 14px;"></i> <!-- Ícono de retiro -->
                        <span style="font-size: 12px;">WITHDRAW</span> <!-- Texto de retiro -->
                    </div>

                    <a v-if="skin.whats_app_mainframe?.enabled"
                        :href="'https://api.whatsapp.com/send?phone=' + skin.whats_app_mainframe.phone_number"
                        id="whatsapp_btn" class="float btn" target="_blank">
                        <img id="whatsapp_logo" class="" src="../../../assets/images/whatsappBtn.png" alt=""
                            width="28px">
                    </a>
                    <div v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.support"
                        class="dropdown nav-item ">
                        <div>
                            <div class="btn-support"
                                :style="skin.header_desktop.support_btn + (this.message_recived ? 'color:white;' : '')"
                                @click="openSupportModalJivo()">
                                <i class="fas fa-comment fa-fw"></i>
                            </div>
                        </div>
                    </div>
                    <div v-if="skin.header_desktop.balance" @click="showBalanceAction" class="nav-item mx-1"
                        :class="skin.my_account.myaccount_type == 'JM' ? '' : 'text-end'"
                        :style="skin.header_desktop.nav_bar_text" style="cursor:pointer">
                        <span class="pr-0 mx-1" style="font-weight: 300;cursor:pointer;">{{
                            user.user_data?.data?.currency == 'USD' ? user.user_data?.data?.currency :
                                translate('credits')
                            }}</span>
                        <!-- <i  class="fas fa-coins pr-0 mx-1"></i> -->
                        <span style="font-weight: 800;">{{ user.user_data.data ? new
                            Intl.NumberFormat("de-DE", {
                                minimumFractionDigits:
                                    skin.qBet_config.decimalsQty, maximumFractionDigits:
                                    skin.qBet_config.decimalsQty
                            }).format(balance.saldo) : 0 }}</span>
                    </div>
                    <div class="user-info mx-1">
                        <div class="avatar px-1 py-1 pb-0">
                            <i class="fa fa-user fa-2x fa-inverse "></i>
                        </div>
                    </div>
                    <div class="dropdown mx-1">
                        <button class="btn btn-dark dropdown-toggle border-radiu btn-sm" type="button"
                            data-bs-toggle="dropdown" aria-expanded="false" style="border-radius:10px">
                            <span style="margin: 20px; font-weight:800"> {{ user.user_data.data ?
                                user.user_data.data.user_name : '' }}</span>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-lg-end">
                            <li><a v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.userMenu.loginHistory"
                                    data-bs-toggle="modal" data-bs-target="#historial_ingresos" class="dropdown-item"
                                    href="#"><i class="fa fa-database"></i> {{ translate('option_user') }}</a></li>
                            <li><a v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.userMenu.changePassword"
                                    id="changePasswordBtn" data-bs-toggle="modal" data-bs-target="#changePasswordJm"
                                    class="dropdown-item" href="#"><i class="fa fa-key"></i>
                                    {{ translate('change_password') }}</a></li>
                            <li><a v-if="skin.header_desktop.userMenu.balanceHistory" @click="getMovements()"
                                    data-bs-toggle="modal" data-bs-target="#myAccountZeus" class="dropdown-item"
                                    href="#"><i class="fa fa-history"></i> {{ translate('account_history') }}</a></li>
                            <li><a v-if="skin.header_desktop.userMenu.sportsRules" @click="terms" class="dropdown-item"
                                    href="#"><i class="fa fa-book"></i> {{ translate('regulations') }}</a></li>
                            <li><a v-if="skin.logout" @click="logout" class="dropdown-item" href="#"><i
                                        class="fa fa-power-off"></i> {{ translate('go_out') }}</a></li>
                        </ul>

                    </div>

                </div>
                <div>
                    <languageSelector :skin="skin" :language="language">
                    </languageSelector>
                </div>
                <div v-if="user.token == '' && skin.register" @click="register"
                    :style="skin.header_desktop.register_btn" class="btn btn-sm text-end">
                    <span style="display:table-cell;vertical-align:middle;">{{ translate("sign_in") }}</span>
                </div>
                <div v-if="user.token == '' && skin.login" @click="login" :style="skin.header_desktop.login_btn"
                    class="btn btn-sm text-end">
                    <span style="display:table-cell;vertical-align:middle;">{{ translate("log_in") }}</span>
                </div>
            </div>

        </nav>
        <div>
            <myAccountZeus v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <!-- Button trigger modal -->
            <button id="transaction_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#transaction"
                style="display:none;"></button>
            <button id="payment_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#payment"
                style="display:none;"></button>
            <button id="withdraw_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#withdraw"
                style="display:none;"></button>
            <button id="login_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#login"
                style="display:none;"></button>
            <button id="register_btn" class="btn btn-primary" data-bs-toggle="modal" href="#registerModalToggle"
                style="display:none;"></button>
            <transaction v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <login2 v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <payment v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <withdraw v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <changePassword v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <misDatos v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <register v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
        </div>
    </div>

</template>


<script>
import ModalJackpot from "../../globaljackpot/ModalJackpot.vue";
import myAccountZeus from "./my_account.vue";
import login2 from "./login.vue";
import withdraw from "../../payments/withdraw.vue";
import payment from "../../payments/payment.vue";
import register from './register.vue';
import languageSelector from './language.vue';
import changePassword from "./changePassword.vue";
import misDatos from "./mis_datos.vue";
import transaction from "../../transaction.vue";

export default {
    name: "mainHeader2",
    props: ['skin', 'language', 'translation'],
    data() {
        return {
            displayModalJackpot: false,
            currentView: '',
            activeColor: this.skin.prematch_all_odds.hover_fondo,
            activeTab: 'home-tab',
            showBalance: false,
            userDataLoaded: false,
            balance: {
                saldo: 0,
                conversion: 0,
                view: "SALDO",
                switch: 1
            },
            newMessage: false,
            supportTickets: []
        }
    },
    components: {
        myAccountZeus,
        payment,
        withdraw,
        login2,
        transaction,
        register,
        languageSelector,
        changePassword,
        misDatos,
        ModalJackpot
    },
    methods: {
        openjackpot() {
            this.displayModalJackpot = !this.displayModalJackpot;
        },
        isActive(item) {
            let val = this.$store.getters['getInfoRouter'];
            if (val) { return item.url === val.url; }
            return;
        },
        openSupportModalJivo() {
            const jivoElement = this.jivoElement1;
            if (this.jivo_modal_flag) {
                if (jivoElement) {
                    jivoElement.style.display = 'none';
                }
                this.$store.dispatch("setJivo_modal_flag", false);
            } else {
                if (jivoElement) {
                    jivoElement.style.display = 'block';
                    jivo_api.open()
                }
                setTimeout(() => {
                    jivo_api.open()
                }, 500);
                this.$store.dispatch("setJivo_modal_flag", true);
                this.$store.dispatch("setMessage", false);

            }
        },
        action() {
            let customButton = this.$props.skin.customActionButton;
            if (customButton.action == 'redirection') {
                let url = customButton.actionData.url;
                let parameters = customButton.actionData.parameters;
                parameters.forEach(param => {
                    url += (url.includes('?') ? '&' : '?') + `${param}=${encodeURIComponent(this.user.user_data.data[param])}`;
                });
                console.log(url, this.user.user_data.data, this.$props.skin.customActionButton);
                window.open(url, '_blank');
            }
        },
        showBalanceAction() {
            if (!this.showBalance) {
                this.$store.dispatch('getProfile', {
                    token: this.user.token,
                    site_id: this.user.site_id,
                    site: this.user.site,
                    prefix: this.user.prefix,
                    playerId: this.user.user_data?.data?.user_id,
                    source: "main"
                });
                this.showBalance = true
            }
            else {
                this.showBalance = false
            }
        },
        getMovements() {
            this.$root.$emit('getMovementsHistory');
        },
        getIngresos() {
            this.$root.$emit('getIngresosHistory');
        },
        balanceParsed(val, fiat) {
            let tasa = 1;
            if (this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false) {
                tasa = this.currency.rate;
            }
            return (fiat != 'BETC' ? (fiat == 'USDT' ? val * tasa : val * tasa * this.user.user_data.data.tasa) : val).toFixed(2);
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        },
        transaction() {
            document.getElementById('transaction_btn').click();
        },
        payment() {
            document.getElementById('payment_btn').click();
            this.$store.dispatch('setPayment')
        },
        withdraw() {
            document.getElementById('withdraw_btn').click();
            this.$store.dispatch('setPayment2')
            this.$store.dispatch('setWithdraw')
        },
        login() {
            document.getElementById('login_btn').click();
        },
        register() {
            document.getElementById('register_btn').click();
        },
        logout() {
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
        my_account() {
            window.parent.postMessage(
                {
                    action: 'openSlider',
                    tab: 'recentBets'
                },
                '*'
            );
        },
        change_view(view) {
            this.$store.dispatch("changeView", view);
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        countDays(init) {
            // Crear dos objetos Date con las fechas que quieres comparar
            var fecha1 = new Date(init);
            var fecha2 = new Date();

            // Calcular la diferencia en milisegundos entre las dos fechas
            var diferenciaEnMilisegundos = fecha2 - fecha1;

            // Convertir la diferencia en días
            var diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

            // Redondear la diferencia si es necesario
            diferenciaEnDias = Math.round(diferenciaEnDias);
            return diferenciaEnDias;
        }
    },
    computed: {
        filteredCategories() {
            return this.$props.skin.categories.filter(category => category.active);
        },
        jivoElement1() {
            return this.$store.getters['jivoElement1'];
        },
        active_item() {
            return {
                "--background": this.$props.skin.header_desktop.nav_bar_item_hover_background,
                "--color": this.$props.skin.header_desktop.nav_bar_item_hover_color,
                "--border": this.$props.skin.header_desktop.nav_bar_item_hover_border,
            }
        },
        activeBarStyle() {
            // console.log(this.skin.header_desktop.servicios)
            return {
                backgroundColor: '1c1c1c',
                color: "#fff",
                borderBottom: `2px solid ${this.skin.header_desktop.nav_bar_text}`
            };
        },
        message_recived() {
            return this.$store.getters["getMessage"]
        },
        user() {
            let data = this.$store.getters['getUserData'];
            if (data.user_data.data) {
                this.balance.saldo = data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
        },
        user_demo() {
            let data = this.$store.getters['getUserDataDemo'];
            if (data.user_data.data) {
                this.balance.saldo = data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
        },
        currency() {
            return this.$store.getters['getCurrency'];
        },
        jivo_modal_flag() {
            return this.$store.getters["getModalFlag"]
        },
        header_productsQty() {
            let products = [this.$props.skin.poker, this.$props.skin.prematch, this.$props.skin.casinoN, this.$props.skin.casino_live, this.$props.skin.hipicas, this.$props.skin.login, this.$props.skin.logout];
            return products.filter(x => x == true).length + 1;
        }
    },
    mounted() {
        this.$store.dispatch("setHeaderHeight", document.getElementById("mainHeader").offsetHeight + 5);
        this.$root.$on('openLogin', () => {
            this.login();
        });
    },
    watch: {
        'user.token'(newVal) {
            if (newVal !== '' && this.skin.jackpot) {
                this.openjackpot();
            }
        },
        showBalance(newVal, oldVal) {
            if (newVal) {
                let self = this
                setTimeout(() => {
                    self.showBalance = false
                }, 5000);
            }
        }
    },
    created() {
        const self = this;
        let balanceRequestTime = 8000;
        var saldo_request = setInterval(function () {
            try {
                // console.log("Actualizando saldo...",self.user.token);
                if (self.user.user_data.data && self.user.token != '') {
                    self.$store.dispatch('getProfile', {
                        token: self.user.token,
                        site_id: self.user.site_id,
                        site: self.user.site,
                        prefix: self.user.prefix,
                        playerId: self.user.user_data?.data?.user_id,
                        source: "main"
                    });
                } else {
                    clearInterval(saldo_request);
                }
            } catch (error) {
                this.$store.dispatch('logOut');
                clearInterval(saldo_request);
            }
        }, balanceRequestTime);
    },
    beforeDestroy() {
        this.$root.$off('openLogin');
    }
}
</script>

<style scoped>
@keyframes blink {
    0% {
        transform: scale(1);
        opacity: 1;
    }

    50% {
        transform: scale(1.05);
        /* Cambio más suave */
        opacity: 0.7;
        /* Menos agresivo */
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}

.jackpot-btn {
    animation: blink 1.5s infinite ease-in-out;
    transition: all 0.3s ease-in-out;
    font-size: 14px;
    padding: 6px;
    margin-right: 5px;
    font-weight: bold;
    border: none;
    cursor: pointer;
    transition: all 0.3s;
    border-radius: 10px;
    text-transform: uppercase;
}

.jackpot-btn:hover {
    animation: none;
}

/* Estilo 1: Brillo dorado */
.gold-glow {
    background: linear-gradient(45deg, var(--color), var(--color1));
    color: var(--colorletter);
    box-shadow: 0 0 15px var(--color);
}

.gold-glow:hover {
    box-shadow: 0 0 30px var(--color);
}

.container-flud {
    border-bottom: 0%;
    padding: 0;

}

.btn-support {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    min-width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
}

.navbar {
    border: none;
    font-size: 12px;
    font-family: sans-serif;
    font-weight: 600;
    padding-top: 0px;
    padding-bottom: 0px;
}

.center_div {
    width: 90%;
    /* Can be in percentage also. */
    height: auto;
    margin: 0;
    padding: 0px;
    position: relative;
}

.dropdown-menu,
.dropdown-item {
    padding: 10px;
    margin-left: 10px;
    border: none;
    border-radius: 10px;
    font-size: 12px;
    font-family: sans-serif;
    font-weight: bold;
    background-color: #1c1c1c;
    /* Color de fondo por defecto */
    color: #fff;
    /* Color del texto por defecto */
}

.nav-tabs {
    border: none !important;
}

.btn-dark,
.avatar {
    font-size-adjust: true;
    border: 1px solid white;
    background-color: #1c1c1c;
    /* Color de fondo por defecto */
    color: #fff;
    /* Color del texto por defecto */
    border-radius: 5px 5px 5px 5px;
}

/* Estilos para los botones */
.nav-link {
    border: none;
    /* Color de fondo por defecto */
    border-bottom: 2px solid transparent;
    color: #fff;
    /* Color del texto por defecto */
    font-weight: bold;
    /* Hace que el texto sea más grueso */
    font-size: 12px "Exo 2";
    padding: 16px;

}

.nav-link.active {
    background-color: var(--background);
    color: var(--color);
    border-bottom: var(--border);
    padding: 16px;
}

/* Estilos para los botones cuando se hace hover */
.nav-link:hover {
    background-color: var(--background);
    /* Color de fondo cuando se hace hover */
    color: var(--color);
    /* Color del texto cuando se hace hover */
    border-bottom: var(--border);
}

.navbar-collapse {
    display: flex;
    align-items: center;
    /* Centra verticalmente los elementos */
    height: 100%;
    /* Establece la altura al 100% del contenedor padre */
    margin: 0;
    padding: 0;
    border: none;
}

.navbar-nav {
    width: 100%;
    /* Ocupa todo el ancho disponible */
    display: flex;
    align-items: center;
    /* Centra verticalmente los elementos */
    justify-content: end;
    /* Alinea los elementos al extremo derecho */
    margin: 0;
    padding: 0;
    border: none;
}

.navbar-nav .nav-item {
    margin-left: auto;
    /* Empuja todos los elementos al extremo derecho */
    margin: 0;
    padding: 0;
    border: none;
}
</style>
